import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
// import { environment } from 'src/environments/environment.prod';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigServiceService {

  constructor(private http: HttpClient) { }

  getUrl(uri:any): any {
    return this.http.get(uri)
    //  .timeout(30000, new Error('delay exceeded'));
  }

  postUrl(uri:any, data:any): any {
      return this.http.post(uri, data)
      //  .timeout(30000, new Error('delay exceeded'));
  }

  getgroup(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllAdminGroupApi.php').pipe(map(res => res))
  }
  getGroupViewData(legalEntityId,groupId): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/ViewSummeryLegalentityApi.php?legalEntityId='+legalEntityId+"&groupId="+groupId).pipe(map(res => res))
  }
  getGroupViewAPI(data){
    return this.getUrl(`${environment.apiUrl}` + '/detailviewstructuralapi.php?legalEntityId='+data.legalEntityId+'&businessSegmentsId='+ 
      
      data.businessSegmentsId+"&locationId="+data.locationId+"&businessAreaId="+data.businessAreaId +"&userId="+data.userId).pipe(map(res => res))
  }
  getDetailViewData(legalEntityId,locationId,businessSegmentsId,businessAreaId): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/ViewDataLegalentityWithUnitApi.php?legalEntityId='+legalEntityId+"&locationId="+locationId+"&businessSegmentsId="+businessSegmentsId+"&businessAreaId="+businessAreaId).pipe(map(res => res))
  }
  SysModuleAccess(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/Usp_Sys_Module_Access_Api.php', data).pipe(map(res => res));
  }
  getmodule(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/get_module.php').pipe(map(res => res))
  }
  //legal entity api start
  viewalllegalentity(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/GetLegalEntityApi.php').pipe(map(res => res))
  }
  viewalllegal(legalEntityId,groupId): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/ViewAdminLegalentityApi.php?legalEntityId='+legalEntityId+"&groupId="+groupId).pipe(map(res => res))
  }
  getlegalentity(data): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/Admin_architecture_getlegalentityApi.php?userId='+data.userId+"&roleID="+data.roleID + "&legalEntityId="+data.legalEntityId).pipe(map(res => res))
  }

  getalldependency(data:any): Observable<any>{
    return this.postUrl(`${environment.apiUrl}` + '/ConfigurationGetalldependencyApi.php',data).pipe(map(res => res))
  }
  
  //end legal entity
  deactivelegalentity(data:any): Observable<any>{
    return this.postUrl(`${environment.apiUrl}` + '/DeleteLegalEntityApi.php',data).pipe(map(res => res))
  }
  activelegalentity(data:any): Observable<any>{
    return this.postUrl(`${environment.apiUrl}` + '/ActiveLegalEntity.php',data).pipe(map(res => res))
  }
  activeInactiveLEadmin(data:any): Observable<any>{
    return this.postUrl(`${environment.apiUrl}` + '/AdminLegalEntityAdminApi.php',data).pipe(map(res => res))
  }
  getallgroup(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/GetallgroupApi.php').pipe(map(res => res))
  }
  getentitytype(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/GetAllEntityTypeApi.php').pipe(map(res => res))
  }
  getorgtype(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/GetOrganizationStatusApi.php').pipe(map(res => res))
  }
  getcorporation(): Observable<any>{
    return this.getUrl(`${environment.apiUrl}` + '/GetCorporateStatusApi.php').pipe(map(res => res))
  }
  addLegalEntitity(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/legalEntityApi.php', data).pipe(map(res => res))
  }
  countlegalEntity(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/CountLegalentity.php').pipe(map(res => res))
  }
  viewLegaentitybyId(id): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewlegalEntityApi.php?id=' + id).pipe(map(res => res))
  }

  updateLegalEntitity(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpadteLegalEntityApi.php', data).pipe(map(res => res))
  }

  //legal entity api end

    //BusinessSegment api end
    // viewallBusinessSegmentNew(id: any,userId): Observable<any> {
    //   return this.getUrl(`${environment.apiUrl}` + '/ViewAllBusinessSegment.php?legalentityId=' + id + 'orlocationId=' + userId).pipe(map(res => res))
    // }
    viewallBusinessSegmentNew(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/ViewAllBusinessSegment.php',data).pipe(map(res => res))
    }
    viewallBusinessSegment(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/ViewAllBusinessSegment.php').pipe(map(res => res))
    }
  
    viewallBusinessVertical(data:any): Observable<any>{
      console.log(data);
      return this.getUrl(`${environment.apiUrl}` + '/ViewAllBusinessSegmentVertical.php?legalentityId='+data.legalentityId+'&locationId='+data.locationId+'&businessSegmentsId='+data.businessSegmentsId+'&groupId='+data.groupId).pipe(map(res => res))
      // return this.postUrl(`${environment.apiUrl}` + '/ViewAllBusinessSegmentVertical.php',data).pipe(map(res => res))
    }
    deactiveBusinessSegment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/DeleteBusinessSegment.php',data).pipe(map(res => res))
    }
    activeBusinessSegment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/ActiveBusinessSegment.php',data).pipe(map(res => res))
    }
    getsegmenttype(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetSegmentTypeApi.php').pipe(map(res => res))
    }
    getbdcode(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/CountBusinessSegment.php').pipe(map(res => res))
    }
    getbsdatabyid(data:any): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/ViewBusinessSegment.php?id='+ data).pipe(map(res => res))
    }
    getBusinessAreabyid(data:any): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/viewAcutalBusinessAreaApi.php?id='+ data).pipe(map(res => res))
    }
    addbddata(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AddBusinessSegment.php',data).pipe(map(res => res))
    }
    updatebddata(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/UpdateBusinessSegment.php',data).pipe(map(res => res))
    }
    AdminLegalEntityAdmin(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AdminLegalEntityAdminApi.php',data).pipe(map(res => res))
    }
    viewLocation(data:any): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/viewAcutalBusinessAreaLocationApi.php?legalEntityId='+ data).pipe(map(res => res))
    }
    //BusinessSegment api end

    // Business Are
    addVertical(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AdminBusinessVerticalApi.php',data).pipe(map(res => res))
    }
    

    viewallBusinessArea(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/ViewallBusinessArea.php').pipe(map(res => res))
    }
    getBusinessUnit(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetBusinessUnitCodeApi.php').pipe(map(res => res))
    }
    GetSingleDependancy(data: any): Observable<any> {
      return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
    }
    // viewallBusinessAreaNew(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/ViewallBusinessArea.php',data).pipe(map(res => res))
    // }
    viewallBusinessAreaNew(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/ViewallBusinessArea.php',data).pipe(map(res => res))
    }
    businessAreaById(data): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/viewBusinessAreaApi.php?id='+data).pipe(map(res => res))
    }

    getLegalEntity(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetLegalEntityApi.php').pipe(map(res => res))
    }
    getBusinesSegmentCode(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetBusinesSegmentCodeApi.php').pipe(map(res => res))
    }
    getHod(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetHodApi.php').pipe(map(res => res))
    }
    getLocation(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetLocation.php').pipe(map(res => res))
    }

    updateBusinessArea(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/UpdateBusinessAreaApi.php',data).pipe(map(res => res))
    }
    addBusinessArea(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AddBusinessAreaApi.php',data).pipe(map(res => res))
    }

    updateBusinessArea1(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/UpdateAcutalBusinessAreaApi.php',data).pipe(map(res => res))
    }
    addBusinessArea1(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AddActualBusinessAreaApi.php',data).pipe(map(res => res))
    }
    viewBusinessArea1(data): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/viewAllAcutalBusinessAreaApi.php?legalEntityId='+data.legalEntityId+
        "&locationId="+data.locationId+"&userId="+data.userId+"&roleId="+data.roleId+"&groupId="+data.groupId).pipe(map(res => res))
    }
    
    countBusinessArea(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/CountBusinessArea.php').pipe(map(res => res))
    }

    deactiveBusinessArea(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/DeleteActualBusinessArea.php',data).pipe(map(res => res))
    }
    activeBusinessArea(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/ActiveActualBusinessArea.php',data).pipe(map(res => res))
    }
  
    //COA

    masterCOA(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/CoaMasterApi.php',data).pipe(map(res => res))
    }
    // getCOAdata(): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_VIEWALLSUBLEDGER.php').pipe(map(res => res))
    // }
    // getMasterSehedules(): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_GETSCHEDULE.php').pipe(map(res => res))
    // }
    // getSubSehedules(id): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_GetSubSchedule.php?id='+id).pipe(map(res => res))
    // }
    // getShedulename(id): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_GETSUBSCHEDULECODE.php?id='+id).pipe(map(res => res))
    // }
    // submitAddGroup(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/COA_ADDGROUP.php',data).pipe(map(res => res))
    // }
    // getGroup(id): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_GETGROUP.php?chartOfAccointId='+id).pipe(map(res => res))
    // }
    // getcode(id): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_VIEWSUBGROUP.php?id='+id).pipe(map(res => res))
    // }
    // submitSubGroup(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/COA_ADDLEDGER.php',data).pipe(map(res => res))
    // }
    // submitLedger(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/COA_ADDSUBLEDGER.php',data).pipe(map(res => res))
    // }
    // deactiveCOA(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/COA_COADELETE.php',data).pipe(map(res => res))
    // }
    // activaCOA(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/ActiveCoa.php',data).pipe(map(res => res))
    // }
    // manageCOA(id): Observable<any>{
    //   return this.getUrl(`${environment.apiUrl}` + '/COA_ViewSubledger.php?id='+id).pipe(map(res => res))
    // }
    // updateCOA(data:any): Observable<any>{
    //   return this.postUrl(`${environment.apiUrl}` + '/COA_UpdateSubledger.php',data).pipe(map(res => res))
    // }
  
    //departmant

    viewallDepartments(data): Observable<any>{
      // "legalEntityId": localStorage.getItem('legalEntityId'),
      //   "businessSegmentsId":localStorage.getItem('businessSegmentsId'),
      //   "locationId":localStorage.getItem('locationId'),
      //    "businessAreaId": localStorage.getItem('businessAreaId'),
      return this.getUrl(`${environment.apiUrl}` + '/ViewalldepartmentsApi.php?legalEntityId='+data.legalEntityId+'&businessSegmentsId='+data.businessSegmentsId+"&locationId="+data.locationId+"&businessAreaId="+data.businessAreaId+"&groupId="+data.groupId).pipe(map(res => res))
    }

    countDepartmentArea(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/CountDepartment.php').pipe(map(res => res))
    }
    
    getCenterType(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetCenterTypeApi.php').pipe(map(res => res))
    }
    getDeptClass(id:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/GetDepartmentByClassificationApi.php', id).pipe(map(res => res))
    }
    GetDeptNameByClassificationAll(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/GetDeptNameByClassificationAll.php', data).pipe(map(res => res))
    }
    getDeptClassDipendancy(): Observable<any> {
      return this.getUrl(`${environment.apiUrl}` + '/GetDepartmentClassificationApi.php').pipe(map(res => res))
    }
    getSysDepartment(): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetSysDepartment.php').pipe(map(res => res))
    }

    getBareaCodeByBscode(id): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetBareaCodeByBscode.php?id='+id).pipe(map(res => res))
    }
    viewDepartmentsById(id): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/ViewDepartmentsApi.php?id='+id).pipe(map(res => res))
    }

    getHodMobileNO(id): Observable<any>{
      return this.getUrl(`${environment.apiUrl}` + '/GetHodMobileNOApi.php?userid='+id).pipe(map(res => res))
    }

    addDepartment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AddDepartmentsApi.php',data).pipe(map(res => res))
    }

    updateDepartment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/UpdateDepartmentsApi.php',data).pipe(map(res => res))
    }

    deactiveDepartment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/DeleteDepartmentsApi.php',data).pipe(map(res => res))
    }
    activeDepartment(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/ActiveDepartmentsApi.php',data).pipe(map(res => res))
    }
    getMyRoleData(userId: any, label: any, legalEntityId: any): Observable<any> {
      const url = `${environment.apiUrl}/Admin_architecture_getlegalentityApi.php?userId=${userId}&roleID=${label}&legalEntityId=${legalEntityId}`;
      return this.http.get<any>(url); 
    }  
    AdminServicePackage(data:any): Observable<any>{
      return this.postUrl(`${environment.apiUrl}` + '/AdminServicePackageApi.php',data).pipe(map(res => res))
    } 
}


